<div class="ignore-container" role="dialog" aria-labelledby="ignore-error-title">
  <div class="ignore-header">
    <div class="icon-circle"><mat-icon>do_not_disturb_on</mat-icon></div>
    <div>
      <h2 id="ignore-error-title">Ignore this error?</h2>
      <p class="header-sub">It will be left out of correction mails and error counts. Other errors are not affected.</p>
    </div>
  </div>

  <div class="error-card">
    <div class="error-label">{{ data.label }}</div>
    <div class="error-message">{{ data.message }}</div>
  </div>

  <label class="field-label" for="ignore-reason">Reason <span class="req">*</span></label>
  <textarea id="ignore-reason" class="form-control" rows="4" [(ngModel)]="reason"
            placeholder="Why is this error being ignored?" [disabled]="saving"></textarea>

  <div class="attach-row">
    <label class="attach-btn" [class.disabled]="saving">
      <mat-icon>attach_file</mat-icon> Add attachments
      <input type="file" multiple hidden (change)="onFiles($event)" [disabled]="saving" />
    </label>
    <span class="attach-hint">Up to 10 MB each</span>
  </div>
  <ul class="file-list" *ngIf="files.length">
    <li *ngFor="let f of files; let i = index">
      <mat-icon>description</mat-icon>
      <span class="file-name">{{ f.name }}</span>
      <span class="file-size">{{ fileSize(f.size) }}</span>
      <button type="button" class="remove" (click)="removeFile(i)" [disabled]="saving" aria-label="Remove file">
        <mat-icon>close</mat-icon>
      </button>
    </li>
  </ul>

  <div class="error-text" *ngIf="errorText">{{ errorText }}</div>

  <div class="actions">
    <button type="button" class="btn btn-light" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!reason.trim() || saving">
      {{ saving ? 'Saving…' : 'Ignore Error' }}
    </button>
  </div>
</div>
